export const overridesHeading = {
  fontSize: "22px",
  lineHeight: "26px",
  fontWeight: 800,
  fontFamily: "MaryAnn, Trebuchet MS, Arial, Helvetica, sans-serif",
  color: "#404040"
};
